export default "__VITE_ASSET__B7RsjuQf__"